import BannerFive from "../components/BannerFive";
import BrandFive from "../components/BrandFive";
import HomeFiveAbout from "../components/HomeFiveAbout";
import HomeFiveBlog from "../components/HomeFIveBlog";
import HomeFiveContact from "../components/HomeFiveContact";
import HomeFiveCounter from "../components/HomeFiveCounter";
import HomeFiveCta from "../components/HomeFiveCta";
import HomeFiveTeam from "../components/HomeFiveTeam";
import PortfoliFive from "../components/PortfolioFive";
import PriceTableFive from "../components/PriceTableFive";
import ServicesFive from "../components/ServicesFive";
import TestimonialFive from "../components/TestimonialFive";
import FooterFive from "../footer/FooterFive";
import HeaderFive from "../header/HeaderFive";

export default function HomeFive(){
    return(
        <>
        <HeaderFive/>
        <main>
        <BannerFive/>
        <ServicesFive/>
        <HomeFiveAbout/>
        <HomeFiveCta/>
        <PriceTableFive/>
        <HomeFiveCounter/>
        <PortfoliFive/>
        <HomeFiveTeam/>
        <BrandFive/>
        <HomeFiveContact/>
        <TestimonialFive/>
        <HomeFiveBlog/>
        </main>
        <FooterFive/>
        </>
    )
}